/**
 * V2 store — minimal pub/sub state container.
 *
 * One-way flow: actions call set(), set() notifies subscribers, subscribers
 * re-render. Views never mutate state directly and never poll.
 */
export function createStore(initialState = {}) {
  let state = { ...initialState };
  const listeners = new Set();

  return {
    get() {
      return state;
    },

    /** Shallow-merge a partial update and notify all subscribers. */
    set(partial) {
      state = { ...state, ...partial };
      for (const fn of listeners) fn(state);
    },

    /** Subscribe to changes. Returns an unsubscribe function. */
    subscribe(fn) {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
  };
}
